import { parseOptionalPage } from '@/lib/urlUtils';

/** Search params of a list that keeps its filters as one encoded `filter` key. */
export type FilterSearchParams = {
    filter?: string;
};

/** The same, for a list that also paginates. */
export type PagedFilterSearchParams = FilterSearchParams & {
    page?: number;
};

export function validateFilterSearch(
    search: Record<string, unknown>,
): FilterSearchParams {
    return {
        filter: typeof search.filter === 'string' ? search.filter : undefined,
    };
}

export function validatePagedFilterSearch(
    search: Record<string, unknown>,
): PagedFilterSearchParams {
    return {
        ...validateFilterSearch(search),
        page: parseOptionalPage(search.page),
    };
}

/**
 * Wraps a never-throwing validator as the schema `useListViewState` checks a
 * restored snapshot against, so it's normalized before being navigated to.
 */
export function asSearchSchema<S extends Record<string, unknown>>(
    validate: (search: Record<string, unknown>) => S,
) {
    return {
        safeParse: (input: unknown) => ({
            success: true as const,
            data: validate(input as Record<string, unknown>),
        }),
    };
}

export const filterSearchSchema = asSearchSchema(validateFilterSearch);
export const pagedFilterSearchSchema = asSearchSchema(
    validatePagedFilterSearch,
);
